import React from "react";
import { CategoryCard } from "../../customChallenges/cards";

import styles from "./desafiosCardCategoria.module.css";

export default function CardCategoriaDesafios({
  index,
  id,
  label,
  image,
  selected,
  onClick,
}) {
  const normal = require(`../../../assets/images/games/hotChallengesCategories/${image}.png`);
  const selecionada = require(`../../../assets/images/games/hotChallengesCategories/${image}_selecionado.png`);

  const handleClick = () => {
    onClick(id);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${styles.card} ${
        index % 2 ? "slide-in-right" : "slide-in-left"
      } ${selected ? styles.selected : ""}`}
    >
      <h2>{label}</h2>
      <div className={styles.image}>
        <img src={selected ? selecionada : normal} alt={label} />
      </div>
    </button>
  );
}

export function CardCategoriaDesafiosEdit({ index, onClick, category }) {
  const handleClick = () => {
    onClick(category);
  };

  return (
    <CategoryCard
      className="overflow-hidden"
      handleClick={handleClick}
      index={index}
    >
      <div className="flex items-center">
        <div className="h-10 w-16 -mt-5 -mb-5 ml-2">
          {category.image ? (
            <img
              className="h-full w-full object-contain"
              src={require(`../../../assets/images/games/hotChallengesCategories/${category.image}.png`)}
              alt=""
            />
          ) : null}
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-bold leading-5 text-center">
            {category.label}
          </h2>
        </div>
      </div>
    </CategoryCard>
  );
}
